import { SOURCE_CELL_REQUIRES_HREF } from 'helpers/tablePolicy';

export const mdToHTML = (md: string, stream=true) => {
  const line = / {0,5}(---|\*\*\*)/g;
  const rxCommonMarkLink = /(\[([^\]]+)])\(([^)]+)\)/g;
  const rxBold = /\*\*([^\*]+)\*\*/g;
  const rxImage = /!\[([^\]]*)]\(([^)]+)\)/g;
  const rxHeadline = /^(#{1,6})\s+(.+?)\s*$/gm;
  const rxHtmlLink = /<a\s+(?!.*?target=)[^>]*?href="([^"]+)"[^>]*?>(.*?)<\/a>/gi;
  const rxAsteriskWithSpace = /^( {0,6})[*-]( {0,3})(?=\S)/gm;
  const rxTable = /((?: {0,4}\|.*?\|\n)+)/g;
  const rexNewLines = /((\r?\n)[ \t]{0,5}){3,}/g;

  const stripInlineHtml = (text: string): string =>
    text.replace(/<(?!a[\s>]|\/a>)[^>]+>/gi, '');

  function parseTable(tableText: string) {
    const rows = tableText.trim().split('\n').filter(r => r.trim() !== '');
    if (rows.length < 2) return tableText;

    const headerCells = rows[0].split('|').slice(1, -1).map(cell => cell.trim());
    const bodyRows = rows.slice(2).map(row => row.split('|').slice(1, -1).map(cell => cell.trim()));

    const sourceHeader = headerCells.find(h => h.toLowerCase() === 'source');

    const tableData = {
      headers: headerCells,
      rows: bodyRows.map(row => {
        const entry = Object.fromEntries(
          headerCells.map((header, i) => [header, stripInlineHtml(row[i] ?? '')])
        );
        if (sourceHeader && entry[sourceHeader] && SOURCE_CELL_REQUIRES_HREF && !/<a\s/i.test(entry[sourceHeader] as string)) {
          entry[sourceHeader] = '';
        }
        return entry;
      }),
    };

    return `__TABLE_JSON_START__${JSON.stringify(tableData)}__TABLE_JSON_END__`;
  }

  // Apply headline conversion first (before other replacements) to handle both stream and non-stream modes
  const headingConverted = md
    ? md.replace(rxHeadline, (_, hashes, title) => {
        const level = hashes.length;
        return `<h${level}><b>${title.trim()}</b></h${level}>`;
      })
    : md;

  const anchor = headingConverted
    ? headingConverted
      .replace(line, "")
      .replace(rxBold, '<b>$1</b>')
      .replace(rxImage, '<img alt="$1" src="$2" style="max-height:500px" rel="noopener noreferrer"/>')
      .replace(rxCommonMarkLink, '<a target="_blank" href="$3">$2</a>')
      .replace(rxHtmlLink, '<a target="_blank" href="$1">$2</a>')
      .replace(rxAsteriskWithSpace, '<div class="half-empty"></div>$1- ')
      .replace(rexNewLines, '\n\n')
    : headingConverted
    ;
  const anchorForTable = anchor && !anchor.endsWith('\n') ? anchor + '\n' : anchor;
  return stream ? anchor : anchorForTable
    .replace(rxTable, (_, table) => parseTable(table));
}
